export function PageHeader({ overline, title, description, actions }) {
  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-7 sm:pt-8 pb-4 sm:pb-5 flex flex-col items-start justify-between gap-3 sm:flex-row sm:gap-4">
      <div className="min-w-0">
        {overline && <div className="text-xs font-medium text-zinc-500 mb-1.5">{overline}</div>}
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-white">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-zinc-400 mt-1.5 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex w-full items-center gap-2 sm:w-auto sm:shrink-0">{actions}</div>}
    </div>
  );
}
